import { string, object, SchemaOf } from 'yup'

export interface IAuthUserUpdateSchema {
    name: string
    cpf: string
    email: string
    currentPassword: string
}

const updateUserSchema: SchemaOf<IAuthUserUpdateSchema> = object().shape({
    name: string().required('Preencha o campo com seu nome.'),
    cpf: string().required('CPF inválido.').required('Preencha o campo com seu CPF.'),
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
    currentPassword: string().required('Confirme sua senha.'),
})

export default updateUserSchema
